export const checkIfTokenValid = (accessTokenExpiry: number) =>
  Date.now() < accessTokenExpiry * 1000 - 10000;

export const getOriginLoginParams = () => ({ originUrl: globalThis.location.origin });
